<!-- 注册表单 -->
<template>
	<el-dialog :title="$t('register')" :visible="visible" width="600px" :close-on-click-modal="false"
		:show-close="false">
		<el-steps :active="stepActive" finish-status="success" align-center process-status="finish"
			style="margin-top: -30px;">
			<el-step :title="$t('emailVerification')"></el-step>
			<el-step :title="$t('setPassword')"></el-step>
		</el-steps>
		<div class="register-layout">
			<el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-width="0">
				<!-- 第一步 -->
				<div v-if="stepActive==0">
					<el-form-item prop="email">
						<div class="form-label">{{ $t('email') }}<span class="required-mark">*</span></div>
						<el-input v-model="registerForm.email" :placeholder="$t('emailPlaceholder')"
							class="register-input"></el-input>
					</el-form-item>
					<el-form-item prop="verificationCode">
						<div class="form-label">{{ $t('verificationCode') }}<span class="required-mark">*</span></div>
						<div class="verification-code-container">
							<el-input v-model="registerForm.verificationCode" :placeholder="$t('enterVerificationCode')"
								class="verification-input"></el-input>
							<div class="captcha-container">
								<canvas ref="captchaCanvas" class="captcha-image" @click="refreshCaptcha"></canvas>
								<i class="el-icon-refresh captcha-refresh" @click="refreshCaptcha"></i>
							</div>
						</div>
						<div class="verification-note">{{$t('verificationCodeNote')}}</div>
					</el-form-item>
					<el-form-item prop="emailCode" v-if="showEmailCode">
						<div class="form-label">{{ $t('emailCode') }}<span class="required-mark">*</span></div>
						<div style="display: flex;">
							<el-input v-model="registerForm.emailCode" :placeholder="$t('enterEmailCode')"
								class="register-input">
							</el-input>
							<el-button :disabled="isCountingDown || !registerForm.email" @click="sendVerificationCode"
								type="primary" class="send-code-button">
								{{ isCountingDown ? `${countdown} ${$t('seconds')}` : $t('sendVerificationCode') }}
							</el-button>
						</div>
					</el-form-item>
				</div>
				<!-- 第二步 -->
				<div v-if="stepActive==1">
					<el-form-item prop="country">
						<div class="form-label">{{ $t('country') }}<span class="required-mark">*</span></div>
						<el-select v-model="registerForm.country" :placeholder="$t('selectCountry')"
							style="width: 100%;" filterable>
							<el-option v-for="item in countries" :key="item.countryCode" :label="`${item.countryName}`"
								:value="item.countryCode">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="password">
						<div class="form-label">{{ $t('setPassword') }}<span class="required-mark">*</span></div>
						<el-input v-model="registerForm.password" type="password" :placeholder="$t('enterPassword')"
							class="register-input"></el-input>
					</el-form-item>
					<el-form-item prop="confirmPassword">
						<div class="form-label">{{ $t('confirmPassword') }}<span class="required-mark">*</span></div>
						<el-input v-model="registerForm.confirmPassword" type="password"
							:placeholder="$t('enterPassword')" class="register-input"></el-input>
					</el-form-item>
					
					<div class="private-layout">
						<el-checkbox v-model="registerForm.agreeToTerms" class="terms-checkbox">
							{{$t('agree')}}
						</el-checkbox>
						<a @click.stop="getPrivacyAgreement('user_agreement')" class="policy-link"
							style="margin-left: 5px;">《{{$t('userAgreement')}}》</a>
						{{$t('and')}}
						<a @click.stop="getPrivacyAgreement('privacy_policy')"
							class="policy-link">《{{$t('privacyPolicy')}}》</a>
					</div>
				</div>
				
				<el-form-item>
					<div style="display: flex;flex-direction: column;margin-top: 20px;">
						<el-button type="primary" @click="nextStep" class="next-button"
							:disabled="!registerForm.email||!registerForm.verificationCode" v-if="stepActive==0"
							:loading="loading">{{ $t('nextStep') }}</el-button>
						<el-button type="primary" @click="nextStep" class="next-button" :disabled="!registerForm.agreeToTerms"
							v-if="stepActive==1" :loading="loading">{{ $t('complete') }}</el-button>
						<el-button @click="cancelRegister" class="cancel-button">{{ $t('cancel') }}</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<el-dialog :title="title" :visible="showPrivateDialog" width="600px" :close-on-click-modal="false"
			append-to-body center @close="showPrivateDialog=false">
			<div style="height: 500px;overflow-y: auto;" v-html="richTextContent"></div>
		</el-dialog>
	</el-dialog>
</template>

<script>
	import userApi from '../api/user'
	import captchaMixin from '../mixins/captcha'
	import {
		md5
	} from "@/utils/md5.js";
	import storage from "@/utils/storage.js";
	export default {
		mixins: [captchaMixin],
		name: 'RegiestDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				showPrivateDialog: false,
				loading: false,
				showEmailCode: false, //是否可以发送邮箱验证码
				stepActive: 0,
				registerForm: {
					email: 'yanhuiqiang1992@163.com',
					verificationCode: '',
					emailCode: '', // 邮箱验证码
					country: '', // 国家
					password: '', // 密码
					confirmPassword: '', // 确认密码
					agreeToTerms: false // 是否同意用户协议和隐私政策
				},
				isCountingDown: false, // 是否正在倒计时
				countdown: 60, // 倒计时秒数
				countries: [],
				timer: null, //倒计时
				richTextContent: '',
				title: ''
			}
		},
		computed: {
			registerRules() {
				return {
					email: [{
							required: true,
							message: this.$t('enterEmail'),
							trigger: 'blur'
						},
						{
							type: 'email',
							message: this.$t('validEmail'),
							trigger: 'blur'
						}
					],
					verificationCode: [{
						required: true,
						message: this.$t('enterVerificationCode'),
						trigger: 'blur'
					}],
					emailCode: [{
						required: true,
						message: this.$t('enterEmailCode'),
						trigger: 'blur'
					}],
					country: [{
						required: true,
						message: this.$t('selectCountry'),
						trigger: 'change'
					}],
					password: [{
							required: true,
							message: this.$t('enterPassword'),
							trigger: 'blur'
						},
						{
							min: 6,
							message: this.$t('passwordMin'),
							trigger: 'blur'
						},
						{
							max: 18,
							message: this.$t('passwordMax'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									callback();
									return;
								}
								// 检查密码强度
								let strength = 0;
								if (/[A-Z]/.test(value)) strength++;
								if (/[a-z]/.test(value)) strength++;
								if (/[0-9]/.test(value)) strength++;
								if (/[^A-Za-z0-9]/.test(value)) strength++;
								if (strength < 2) {
									callback(new Error(this.$t('passwordStrength')));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					confirmPassword: [{
							required: true,
							message: this.$t('enterConfirmPassword'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									callback();
									return;
								}
								if (value !== this.registerForm.password) {
									callback(new Error(this.$t('passwordMismatch')));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					agreeToTerms: [{
						validator: (rule, value, callback) => {
							if (!value) {
								callback(new Error(this.$t('agreeToTermsRequired')));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}]
				};
			}
		},
		mounted() {
			// 初始化验证码
			if (this.visible) {
				this.$nextTick(() => {
					this.refreshCaptcha()
				})
			}
		},
		watch: {
			visible(newVal) {
				if (newVal) {
					// 当组件显示时，生成验证码
					this.$nextTick(() => {
						if (this.timer) {
							clearInterval(this.timer);
						}
						this.resetForm();
						this.refreshCaptcha();
						this.getCountryCode();
					})
				}
			}
		},
		created() {
		},
		methods: {
			//获取隐私条款、用户协议、关于我们
			async getPrivacyAgreement(type) {
				this.title = type == 'user_agreement' ? this.$t('userAgreement') : this.$t('privacyPolicy')
				const res = await userApi.getPrivacyAgreement(type, storage.getLanguage());
				if (res.success) {
					this.richTextContent = res.result ? res.result.content : '暂无数据'
				}
				this.showPrivateDialog = true;
			},
			//获取国家列表数据
			async getCountryCode() {
				const res = await userApi.getCountryCode();
				this.countries = res.result.countryCodeItems;
			},
			//检查邮箱是否存在
			async checkEmail() {
				// 图形验证码是否正确
				if (this.registerForm.verificationCode.toLowerCase() !== this.captchaCode.toLowerCase()) {
					this.refreshCaptcha();
					return this.$message.error(this.$t('verificationCodeError'));
				}
				const res = await userApi.checkEmail(this.registerForm.email);
				if (res.success) {
					return this.$message.warning(this.$t('emailExist'));
				}
				//邮箱不存在，则直接发送验证码
				this.sendVerificationCode();
			},
			//验证邮箱验证码
			async checkEmailCode() {
				const res = await userApi.checkEmailCode({
					email: this.registerForm.email,
					code: this.registerForm.emailCode,
					verificationEnums: 'REGISTER'
				})
				if (res.code == 200) {
					if (this.timer) {
						clearInterval(this.timer)
					}
					this.stepActive = 1;
				} else {
					this.$message.error(this.$t('emailCodeErr'))
				}
			},
			nextStep() {
				this.$refs.registerForm.validate((valid) => {
					if (valid) {
						if (this.stepActive === 0) {
							if (!this.showEmailCode) {
								//需要先检查邮箱是否存在，如果存在提示可以直接登录，如果不存在则验证图形验证码是否一致，一致则发送邮箱验证码
								this.checkEmail();
							} else {
								// 验证邮箱验证码，通过，进入下一步
								this.checkEmailCode();
							}
						} else if (this.stepActive === 1) {
							this.loading = true;
							this.confirmRegister();
						}
					} else {
						return false;
					}
				});
			},
			async confirmRegister() {
				const data = {
					username: this.registerForm.email,
					email: this.registerForm.email,
					code: this.registerForm.emailCode,
					password: md5(this.registerForm.password),
					countryCode: this.registerForm.country
				};
				const res = await userApi.userRegiest(data);
				if (res.success) {
					// 注册完成
					this.$message.success(this.$t('registerSuccess'));
					// 先重置表单，再关闭对话框
					this.stepActive = 0;
					this.$emit('update:visible', false);
					this.loading = false;
				}
			},
			cancelRegister() {
				this.$confirm(this.$t('cancelRegistration'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning',
					showClose: false
				}).then(() => {
					this.$emit('update:visible', false);
					this.stepActive = 0;
				}).catch(() => {});
			},
			// 发送邮箱验证码
			async sendVerificationCode() {
				console.log("发送邮箱验证码")
				// 验证邮箱格式
				this.$refs.registerForm.validateField('email', async (error) => {
					if (!error) {
						this.loading = true;
						const res = await userApi.sendRegisterEmail('REGISTER', this.registerForm.email);
						this.loading = false;
						if (res.code == 80201 && res.success) {
							this.showEmailCode = true;
							// 开始倒计时
							this.isCountingDown = true;
							this.countdown = 60;
							// 倒计时逻辑
							const timer = setInterval(() => {
								this.countdown--;
								if (this.countdown <= 0) {
									clearInterval(timer);
									this.isCountingDown = false;
								}
							}, 1000);
							this.$message.success(this.$t('verificationCodeSent'));
						} else {
							this.$message.success(res.message);
						}
					}
				});
			},
			//重置表单
			resetForm() {
				this.registerForm = {
					email: '',
					verificationCode: '',
					emailCode: '', // 邮箱验证码
					country: '', // 国家
					password: '', // 密码
					confirmPassword: '', // 确认密码
					agreeToTerms: false // 是否同意用户协议和隐私政策
				}
			}
		},
	}
</script>

<style scoped>
	:deep .el-form-item {
		margin-bottom: 15px;
	}

	/* Register Form Styles */
	.register-layout {
		padding: 20px;
	}

	.form-label {
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}

	.required-mark {
		color: #ff4d4f;
		margin-left: 4px;
	}

	.register-input,
	.verification-input {
		width: 100%;
		height: 40px;
		font-size: 14px;
	}

	.verification-code-container {
		display: flex;
		align-items: center;
		gap: 15px;
	}

	.verification-input {
		flex: 1;
		height: 40px;
		font-size: 14px;
	}

	.captcha-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.captcha-image {
		width: 120px;
		height: 40px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		cursor: pointer;
	}

	.captcha-refresh {
		color: #999;
		cursor: pointer;
		font-size: 16px;
	}

	.captcha-refresh:hover {
		color: #1890ff;
	}

	.send-code-button {
		height: 40px;
		font-size: 14px;
		background-color: #0167F7;
		border-color: #0167F7;
		color: #fff;
		padding: 0 15px;
		border-radius: 4px;
	}

	.send-code-button:hover {
		background-color: #409EFF;
		border-color: #409EFF;
	}

	.verification-note {
		font-size: 13px;
		color: #aaa;
		line-height: 16px;
		margin-top: 10px;
	}

	.next-button {
		height: 50px;
		font-size: 16px;
		background-color: #0167F7;
		border-color: #0167F7;
		color: #fff;
		margin-bottom: 10px;
	}

	.next-button:hover {
		background-color: #409EFF;
		border-color: #409EFF;
	}

	.cancel-button {
		height: 50px;
		font-size: 16px;
		margin-left: 0 !important;
	}

	.private-layout {
		margin: 20px 0;
	}

	.terms-checkbox {
		font-size: 14px;
		color: #333;
	}

	.policy-link {
		color: #016AF8 !important;
		text-decoration: none;
		cursor: pointer;
	}

	.policy-link:link {
		color: #016AF8 !important;
		text-decoration: none;
		cursor: pointer;
	}

	.policy-link:hover {
		color: #016AF8 !important;
	}

	.policy-link:visited {
		color: #016AF8 !important;
	}

	/* El Input Bottom Border Only */
	.el-input__inner {
		border: none;
		border-bottom: 1px solid #d9d9d9;
		border-radius: 0;
		box-shadow: none;
	}

	.el-input__inner:focus {
		border-bottom-color: #1890ff;
		box-shadow: none;
	}

	.el-input {
		--el-input-bg-color: transparent;
		--el-input-border-color: transparent;
		--el-input-focus-border-color: transparent;
		--el-input-hover-border-color: transparent;
	}
</style>